import { FormControl } from "@angular/forms";

export function extensionMatch( valid:  string | string[] ) {
    return function ( control: FormControl ) {
      const file = control.value;
      if ( file ) {
        const fileName = file?.name as string ;
        if( !fileName ) return { requiredFileType: true };

        const splitted = fileName.split('.')

        if( !splitted && splitted.length <= 1 ) return { requiredFileType: true };

        const extension = splitted[splitted.length-1].toLowerCase()

        console.log(extension); 

        if( valid instanceof Array ) {

            for( let ext of valid ){
              if ( ext.toLowerCase() == extension.toLowerCase() ) 
                return null
            }
            return {
              requiredFileType: true
            };
        }else{
            if ( valid.toLowerCase() != extension.toLowerCase() ) {
                return {
                  requiredFileType: true
                };
            }
        }
  
        return null;
      }
  
      return null;
    };
}
  